import {
  FLOW_SESSION_MODES,
  FlowSessionMode,
  MetadataIcon,
} from "@cohesive/api-client";

interface ModeMeta {
  label: string;
  icon: MetadataIcon;
}

/**
 * Per-mode display metadata (label + icon) for flow sessions, keyed by
 * FlowSessionMode. Drives chat icons (SessionNameMenu, RecentChats) and
 * process labels (CanvasProcessContext).
 */
export const MODE_META: Record<FlowSessionMode, ModeMeta> = {
  [FLOW_SESSION_MODES.WORKSPACE_CHAT]: {
    label: "Cohesive Assistant",
    icon: { type: "lucide", lucide: { name: "Bot", color: "#337EA9" } },
  },
  [FLOW_SESSION_MODES.CANVAS_CHAT]: {
    label: "Canvas Workspace",
    icon: {
      type: "lucide",
      lucide: { name: "LayoutDashboard", color: "#8B5CF6" },
    },
  },
  [FLOW_SESSION_MODES.CANVAS_ONBOARDING]: {
    label: "Canvas Onboarding Demo",
    icon: { type: "lucide", lucide: { name: "Sparkles", color: "#7C3AED" } },
  },
  [FLOW_SESSION_MODES.CANVAS_SUBAGENT_ASYNC]: {
    label: "Canvas Delegate (Async)",
    icon: { type: "lucide", lucide: { name: "GitBranch", color: "#8B5CF6" } },
  },
  [FLOW_SESSION_MODES.CANVAS_SUBAGENT_SYNC]: {
    label: "Canvas Delegate (Sync)",
    icon: { type: "lucide", lucide: { name: "GitMerge", color: "#8B5CF6" } },
  },
};

/** Icon for a session mode; undefined-safe for loading/partial sessions. */
export function flowSessionModeIcon(
  mode: FlowSessionMode | undefined,
): MetadataIcon | undefined {
  return mode ? MODE_META[mode]?.icon : undefined;
}

/** Display label for a session mode; undefined-safe for loading/partial sessions. */
export function flowSessionModeLabel(
  mode: FlowSessionMode | undefined,
): string | undefined {
  return mode ? MODE_META[mode]?.label : undefined;
}
